<template>
  <div>
    <v-card flat class="rounded-lg pa-6">
      <div>
        <title-page
          back="true"
          :align="'center'"
          colorIconBack="#006341"
          title="Documentation Sponsorship"
        />
      </div>
    </v-card>
    <v-card flat class="rounded-lg pa-6 mt-6">
      <div>
        <h4>Title of Proposal</h4>
        <v-text-field
          v-if="dataSet && !loading"
          class="d-flex align-center mt-2 rounded-lg"
          dense
          outlined
          filled
          readonly
          v-model="dataSet[0].title"
          placeholder="Put the title here"
          hide-details
          color="green"
          style="width: 30%"
        ></v-text-field>
        <v-skeleton-loader
          class="mt-2"
          width="150px"
          height="30px"
          v-if="loading"
          type="image"
        ></v-skeleton-loader>
      </div>
      <div class="mt-6">
        <h4>Description</h4>
        <v-textarea
          v-if="dataSet && !loading"
          class="d-flex align-center mt-2 rounded-lg"
          auto-grow
          outlined
          rows="4"
          placeholder="Put the description here"
          v-model="dataSet[0].description"
          filled
          readonly
          color="green"
          hide-details
          dense
        ></v-textarea>

        <v-skeleton-loader
          height="90px"
          class="mt-2"
          width="150px"
          v-if="loading"
          type="image"
        ></v-skeleton-loader>
      </div>
      <div class="mt-6">
        <h4>Type of Sponsorship</h4>
        <v-select
          v-if="!loading && dataSet"
          class="my-2 rounded-lg"
          dense
          outlined
          filled
          readonly
          :items="optDestinationProposal"
          item-text="name"
          item-value="val"
          v-model="dataSet[0].destination"
          placeholder="Choose Status Internship"
          flat
          hide-details
          style="width: 50%"
        ></v-select>
        <v-skeleton-loader
          class="mt-2"
          width="150px"
          v-if="loading"
          height="30px"
          type="image"
        ></v-skeleton-loader>
      </div>
      <div class="mt-2">
        <h4>Link for Documentation</h4>
        <h6 class="mt-2">Additional Link</h6>
        <v-textarea
          v-if="dataContent && !loading"
          class="my-4 rounded-lg"
          auto-grow
          outlined
          rows="4"
          placeholder="Put the description here"
          v-model="dataContent.content"
          hide-details
          dense
        ></v-textarea>
        <v-textarea
          v-if="!dataContent && !loading"
          class="my-4 rounded-lg"
          auto-grow
          outlined
          rows="4"
          placeholder="Put the description here"
          v-model="content"
          hide-details
          dense
        ></v-textarea>
        <v-btn
          v-if="dataContent && !loading"
          target="blank"
          color="green"
          depressed
          dark
          class="btn"
          :href="dataContent.content"
        >
          <v-icon class="mr-2">mdi-link-variant</v-icon>
          to Link</v-btn
        >
        <v-skeleton-loader
          class="mt-2"
          v-if="loading"
          height="90px"
          type="image"
        ></v-skeleton-loader>
      </div>
      <div v-if="(!loading && dataContent) || content" class="d-flex my-2">
        <v-btn
          class="bg_default text-capitalize rounded-lg"
          depressed
          dark
          @click="saveData"
          >SAVE</v-btn
        >
      </div>
    </v-card>
  </div>
</template>

<script>
import titlePage from "../../../../../components/atom/titlePage.vue";
export default {
  components: { titlePage },
  name: "dokumentasiSponsorship",
  data() {
    return {
      optDestinationProposal: [
        { name: "Acara", val: "acara" },
        { name: "Konferensi", val: "konferensi" },
        { name: "Lomba", val: "lomba" },
        { name: "Sertifikasi", val: "sertifikasi" },
      ],
      loading: true,
      dataSet: null,
      dataContent: null,
      content: "",
    };
  },
  mounted() {
    this.fetchDataContent();
  },
  methods: {
    saveData() {
      this.loading = true;
      let body = {
        id: this.$route.params.idProposal,
        content: this.dataContent ? this.dataContent.content : this.content,
        name: this.dataSet[0].title,
        description: this.dataSet[0].description,
      };
      let data = {
        path: `scholar/proposal/sponsorships/dokumen`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.content = "";
          this.fetchDataContent();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar/proposal/sponsorships?sort=-created_at&filter[id]=${this.$route.params.idProposal}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchDataContent() {
      this.loading = true;
      let data = {
        path: `scholar/proposal/sponsorships/dokumen?id=${this.$route.params.idProposal}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataContent = data;
          this.fetchData();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
